/* @flow */
import React from 'react';
import AddButton from 'components/AddButton.jsx';
import AddParentChildModal from './AddParentChildModal.jsx';
import Fieldset from 'components/Fieldset.jsx';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Legend from 'components/Legend.jsx';
import minimalRelatedUserFragment from 'user/fragments/minimalRelatedUserFragment.gql';
import { mountModal } from 'lib/modal';
import UserParentChildRow from 'settings/components/UserParentChildRow.jsx';

import 'settings/components/styles/UserParentChildSection.scss';

type MinimalRelatedUser = {
  id: number,
}

type Props = {
  relation: 'parent' | 'child',
  related_users: [MinimalRelatedUser],
  pending_related_users: [MinimalRelatedUser],
  permissions: Object,
};

class UserParentChildSection extends React.Component {
  props: Props;
  state = {};

  addParentChild = () => {
    mountModal(
      <AddParentChildModal
        relation={this.props.relation}
        title={this.getAddText()}
        onRequestHide={() => {}}
      />,
      this
    );
  }

  getAddText() {
    return this.props.relation === 'parent' ? 'Add your parent' : 'Add your child';
  }

  renderAddButton() {
    const { relation, permissions } = this.props;
    if ((relation === 'parent' && permissions.can_add_parent) ||
        (relation === 'child' && permissions.can_add_child)) {
      return (
        <AddButton
          className="UserParentChildSection-add-button"
          onClick={this.addParentChild}
          size="large">
          {this.getAddText()}
        </AddButton>
      );
    }
    return null;
  }

  render = () => {
    const titleText = this.props.relation === 'parent' ? 'Parents' : 'Children';
    return (
      <Fieldset>
        <Legend>{titleText}</Legend>
        <table className="UserParentChildSection-table">
          <tbody>
            {this.props.related_users.map(u =>
              <UserParentChildRow
                key={u.id}
                relation={this.props.relation}
                related_user={u}
              />
            )}
            {this.props.pending_related_users.map(u =>
              <UserParentChildRow
                key={u.id}
                relation={this.props.relation}
                related_user={u}
                pending
              />
            )}
          </tbody>
        </table>
        {this.renderAddButton()}
      </Fieldset>
    );
  }
}

const withPermissions = graphql(gql`
  query {
    me {
      permissions {
        can_add_parent
        can_add_child
      }
      family {
        children {
          ...minimalRelatedUser
        }
        pending_children {
          ...minimalRelatedUser
        }
        parents {
          ...minimalRelatedUser
        }
        pending_parents {
          ...minimalRelatedUser
        }
      }
    }
  }
  ${minimalRelatedUserFragment}
  `,
  {
    props: ({ data, ownProps }) => {
      const familyKey = ownProps.relation === 'parent' ? 'parents' : 'children';
      const pendingFamilyKey = ownProps.relation === 'parent' ? 'pending_parents' : 'pending_children';

      return {
        permissions: data.me ? data.me.permissions : {},
        related_users: data.me ? data.me.family[familyKey] : [],
        pending_related_users: data.me ? data.me.family[pendingFamilyKey] : [],
      };
    },
  }
);

export { UserParentChildSection };
export default withPermissions(UserParentChildSection);



// WEBPACK FOOTER //
// ./src/settings/components/UserParentChildSection.jsx